import { useQuery } from "@hooks/useQuery";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { DynamicForm, FormConfig } from "~/Components/DynamicForm/DynamicForm";
import { useNotification } from "~/Hooks/useNotification";
import { useDocumentDetails } from "~/Modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { post, put } from "~/Services";
import { centralizedHost } from "~/Utils";
import { decodeHTML } from "~/Utils/CommonUtils";
import { appendSasToken, removeSasFromDescription } from "../../Imagehelper";
import { useLagsSection1 } from "../TravellersInfo.hook";
import { fields } from "../constants";

export const CentralizedLagsSection1 = () => {
  const { openToast } = useNotification();
  const query = useQuery();
  const navigate = useNavigate();
  const subActiveTab = query.get("subActiveTab");

  const {
    data: singleCabinLuggagePolicy,
    isLoading: isLoadingSingleCabinLuggagePolicy,
    refetch: refetchsingleCabinLuggagePolicy,
  } = useLagsSection1();
  const {
    data: travellersInfoById,
    isLoading: isLoadingTravellersInfoById,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    } else {
      refetchsingleCabinLuggagePolicy();
    }
  }, [query.get("id")]);

  const singleCabinLuggagePolicyFormConfig: FormConfig = {
    initialValues: {
      image: travellersInfoById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "brandImage.png",
              status: "done",
              url: appendSasToken(travellersInfoById?.payload?.image),
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "brandImage.png",
              status: "done",
              url: appendSasToken(singleCabinLuggagePolicy?.[0]?.image),
            },
          ]),
      tab_title_english: travellersInfoById
        ? decodeHTML(travellersInfoById.payload.tab_title_english)
        : singleCabinLuggagePolicy
          ? decodeHTML(singleCabinLuggagePolicy?.[0]?.tab_title_english)
          : "",
      tab_title_malay: travellersInfoById
        ? decodeHTML(travellersInfoById.payload.tab_title_malay)
        : singleCabinLuggagePolicy
          ? decodeHTML(singleCabinLuggagePolicy?.[0].tab_title_malay)
          : "",
      tab_title_mandarin: travellersInfoById
        ? decodeHTML(travellersInfoById.payload.tab_title_mandarin)
        : singleCabinLuggagePolicy
          ? decodeHTML(singleCabinLuggagePolicy?.[0]?.tab_title_mandarin)
          : "",

      title_mandarin: travellersInfoById
        ? decodeHTML(travellersInfoById.payload.title_mandarin)
        : singleCabinLuggagePolicy
          ? decodeHTML(singleCabinLuggagePolicy?.[0]?.title_mandarin)
          : "",
      title_malay: travellersInfoById
        ? decodeHTML(travellersInfoById.payload.title_malay)
        : singleCabinLuggagePolicy
          ? decodeHTML(singleCabinLuggagePolicy?.[0]?.title_malay)
          : "",
      title: travellersInfoById
        ? decodeHTML(travellersInfoById.payload.title)
        : singleCabinLuggagePolicy
          ? decodeHTML(singleCabinLuggagePolicy?.[0]?.title)
          : "",
      body: travellersInfoById
        ? decodeHTML(travellersInfoById.payload.body)
        : singleCabinLuggagePolicy
          ? decodeHTML(singleCabinLuggagePolicy?.[0]?.body)
          : "",
      description_malay_1: travellersInfoById
        ? decodeHTML(travellersInfoById.payload.description_malay_1)
        : singleCabinLuggagePolicy
          ? decodeHTML(singleCabinLuggagePolicy?.[0]?.description_malay_1)
          : "",
      description_mandarin_1: travellersInfoById
        ? decodeHTML(travellersInfoById.payload.description_mandarin_1)
        : singleCabinLuggagePolicy
          ? decodeHTML(singleCabinLuggagePolicy?.[0]?.description_mandarin_1)
          : "",
      description_english_2: travellersInfoById
        ? decodeHTML(travellersInfoById.payload.description_english_2)
        : singleCabinLuggagePolicy
          ? decodeHTML(singleCabinLuggagePolicy?.[0]?.description_english_2)
          : "",
      description_malay_2: travellersInfoById
        ? decodeHTML(travellersInfoById.payload.description_malay_2)
        : singleCabinLuggagePolicy
          ? decodeHTML(singleCabinLuggagePolicy?.[0]?.description_malay_2)
          : "",
      description_mandarin_2: travellersInfoById
        ? decodeHTML(travellersInfoById.payload.description_mandarin_2)
        : singleCabinLuggagePolicy
          ? decodeHTML(singleCabinLuggagePolicy?.[0]?.description_mandarin_2)
          : "",
      description_english_3: travellersInfoById
        ? decodeHTML(travellersInfoById.payload.description_english_3)
        : singleCabinLuggagePolicy
          ? decodeHTML(singleCabinLuggagePolicy?.[0]?.description_english_3)
          : "",
      description_malay_3: travellersInfoById
        ? decodeHTML(travellersInfoById.payload.description_malay_3)
        : singleCabinLuggagePolicy
          ? decodeHTML(singleCabinLuggagePolicy?.[0]?.description_malay_3)
          : "",
      description_mandarin_3: travellersInfoById
        ? decodeHTML(travellersInfoById.payload.description_mandarin_3)
        : singleCabinLuggagePolicy
          ? decodeHTML(singleCabinLuggagePolicy?.[0]?.description_mandarin_3)
          : "",
      description_english_4: travellersInfoById
        ? decodeHTML(travellersInfoById.payload.description_english_4)
        : singleCabinLuggagePolicy
          ? decodeHTML(singleCabinLuggagePolicy?.[0]?.description_english_4)
          : "",
      description_malay_4: travellersInfoById
        ? decodeHTML(travellersInfoById.payload.description_malay_4)
        : singleCabinLuggagePolicy
          ? decodeHTML(singleCabinLuggagePolicy?.[0]?.description_malay_4)
          : "",
      description_mandarin_4: travellersInfoById
        ? decodeHTML(travellersInfoById.payload.description_mandarin_4)
        : singleCabinLuggagePolicy
          ? decodeHTML(singleCabinLuggagePolicy?.[0]?.description_mandarin_4)
          : "",
      description_english_5: travellersInfoById
        ? decodeHTML(travellersInfoById.payload.description_english_5)
        : singleCabinLuggagePolicy
          ? decodeHTML(singleCabinLuggagePolicy?.[0]?.description_english_5)
          : "",
      description_malay_5: travellersInfoById
        ? decodeHTML(travellersInfoById.payload.description_malay_5)
        : singleCabinLuggagePolicy
          ? decodeHTML(singleCabinLuggagePolicy?.[0]?.description_malay_5)
          : "",
      description_mandarin_5: travellersInfoById
        ? decodeHTML(travellersInfoById.payload.description_mandarin_5)
        : singleCabinLuggagePolicy
          ? decodeHTML(singleCabinLuggagePolicy?.[0]?.description_mandarin_5)
          : "",
    },
    fields: fields.centralizedLagsPageContent,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = ["image"];
    for (const key of imageKeys) {
      const field = data[key];

      try {
        if (field?.[0]?.originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "CENTRALIZED");
          const res: any = await post("management/upload-file", formData);
          if (res) data[key] = res.response.data;
        } else if (field?.[0]?.url) {
          const cleanUrl = field[0].url.split("?sp=")[0];
          data[key] = cleanUrl;
        } else if (Array.isArray(field) && field.length === 0) {
          data[key] = "";
        } else if (!field) {
          data[key] = "";
        }
      } catch (error) {
        console.error(`Error handling image field ${key}:`, error);
      }
    }

    let descriptionKeys: any = [
      "description_english_1",
      "description_malay_1",
      "description_mandarin_1",
      "description_english_2",
      "description_malay_2",
      "description_mandarin_2",
      "description_english_3",
      "description_malay_3",
      "description_mandarin_3",
      "description_english_4",
      "description_malay_4",
      "description_mandarin_4",
      "description_english_5",
      "description_malay_5",
      "description_mandarin_5",
    ];
    for (const key of descriptionKeys) {
      if (data[key]) {
        data[key] = removeSasFromDescription(data[key]);
      }
    }

    const payload = {
      action: action,
      method: method,
      module: "Lags & Restricted Items",
      subModule: "centralizedLags_centralizedLagsPageContent",
      type: "CENTRALIZED",
      application: "CENTRALIZED",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "CENTRALIZED",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && { id: singleCabinLuggagePolicy?.[0]?.id || travellersInfoById?.payload?.id }),
        ...data,
        published: true,
      },
      status: status,
    };
    console.log(payload, "payload");
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/centralized/status-information?activeTab=pending");
          } else {
            navigate("/centralized/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/centralized/status-information?activeTab=pending");
          } else {
            navigate("/centralized/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    // <ContentWrapper>
    <DynamicForm
      isLoading={isLoadingSingleCabinLuggagePolicy || isLoadingTravellersInfoById}
      config={singleCabinLuggagePolicyFormConfig}
      onSubmit={(data, buttonValue, reviewNotes) =>
        onSubmit(
          data,
          `${centralizedHost}/api/lags/section-one/${singleCabinLuggagePolicy?.[0]?.id || travellersInfoById?.payload?.id}`,
          "UPDATE",
          "PATCH",
          buttonValue === "save" ? "DRAFT" : "PENDING",
          reviewNotes
        )
      }
      defaultReviewNotes="Kindly review this Lags & Restricted Items"
    />
    // </ContentWrapper>
  );
};
